export function getAccountingYear(
  fiscalYearStartDate: string,
  fiscalYearEndDate: string
) {
  const startDateYear = new Date(fiscalYearStartDate).getFullYear();
  const endDateYear = new Date(fiscalYearEndDate).getFullYear();

  return startDateYear === endDateYear
    ? startDateYear
    : `${startDateYear} - ${endDateYear}`;
}
